module.exports = __webpack_public_path__ + "img/ID.d5fbe448.svg";